import apiClient from "./axios";

// Get all locations with optional filtering
export const getLocations = async (params = {}) => {
  const { data } = await apiClient.get("/locations", { params });
  return data;
};

// Get a specific location by ID
export const getLocation = async (id) => {
  const { data } = await apiClient.get(`/locations/${id}`);
  return data;
};

// Get location by slug
export const getLocationBySlug = async (slug) => {
  const { data } = await apiClient.get(`/locations/slug/${slug}`);
  return data;
};

// Create a new location
export const createLocation = async (locationData) => {
  const { data } = await apiClient.post("/locations", locationData);
  return data;
};

// Update an existing location
export const editLocation = async ({ id, ...locationData }) => {
  const { data } = await apiClient.patch(`/locations/${id}`, locationData);
  return data;
};

// Delete a location (soft delete)
export const deleteLocation = async (id) => {
  const { data } = await apiClient.delete(`/locations/${id}`);
  return data;
};

// Get all locations without pagination
export const getAllLocations = async (params = {}) => {
  const { data } = await apiClient.get("/locations", { 
    params: { ...params, all: true } 
  });
  return data;
};

// Search locations by name
export const searchLocations = async (searchTerm, params = {}) => {
  const { data } = await apiClient.get("/locations", { 
    params: { ...params, search: searchTerm } 
  });
  return data;
};

// Get trashed locations
export const getTrashedLocations = async (params = {}) => {
  const { data } = await apiClient.get("/locations/trashed", { params });
  return data;
};

// Restore a trashed location
export const restoreLocation = async (id) => {
  const { data } = await apiClient.post(`/locations/${id}/restore`);
  return data;
};